import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as S from './styles'
import { SidebarLateralProps } from './types'
import { SidebarMenuItem } from './SidebarMenuItem'
import { DEFAULT_SIDEBAR_LOGO_URL } from '../../../constants/zingConfigInfo'
import { trans } from '../../../i18n/translate'

const SidebarLateral = ({
  menuItems,
  isOpen,
  onToggle,
  logo,
  topLogo,
  iconSize,
  itemGap,
  topGap,
  logoFooterBottom,
  collapsedWidth,
  menuMaxHeight,
}: SidebarLateralProps) => (
  <>
    <S.SidebarWrapper
      $isOpen={isOpen}
      $fullHeight={!!topLogo}
      $collapsedWidth={collapsedWidth}
    >
      {topLogo && (
        <S.TopLogoWrapper type="button" onClick={topLogo.onClick} aria-label={trans('logo')}>
          <S.TopLogoImg
            src={isOpen ? topLogo.expanded : topLogo.collapsed}
            alt={trans('logo')}
            $isOpen={isOpen}
            $expandedWidth={topLogo.expandedWidth}
            $expandedHeight={topLogo.expandedHeight}
            $collapsedWidth={topLogo.collapsedWidth}
            $collapsedHeight={topLogo.collapsedHeight}
          />
        </S.TopLogoWrapper>
      )}
      <S.MenuNav>
        <S.MenuList $topGap={topGap} $maxHeight={menuMaxHeight}>
          {menuItems.map((item, i) => (
            <SidebarMenuItem
              key={i}
              item={item}
              isOpen={isOpen}
              iconSize={iconSize}
              itemGap={itemGap}
            />
          ))}
        </S.MenuList>
      </S.MenuNav>

      {logo && (
        <S.SidebarFooter
          href={DEFAULT_SIDEBAR_LOGO_URL}
          target="_blank"
          rel="noreferrer"
          $bottom={logoFooterBottom}
        >
          <S.FooterLogo src={logo} alt={trans('logo')} $isOpen={isOpen} />
        </S.SidebarFooter>
      )}
    </S.SidebarWrapper>

    <S.ToggleButton
      type="button"
      $isOpen={isOpen}
      $collapsedWidth={collapsedWidth}
      onClick={() => onToggle(!isOpen)}
      aria-label={isOpen ? trans('Fechar menu') : trans('Abrir menu')}
    >
      <FontAwesomeIcon size="xs" icon={['fas', isOpen ? 'chevron-left' : 'chevron-right']} />
    </S.ToggleButton>
  </>
)

export default SidebarLateral
